import { useState } from 'react';
import { authApi } from '../api/auth.api';
import type { ResetPasswordRequest } from '../types/auth.type';
import type { ApiError, ErrorState } from '../types/page.type';
import { getErrorMessage } from '@/core/api/error-messages';

export function useResetPassword() {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [errorState, setErrorState] = useState<ErrorState | null>(null);

  const resetPassword = async (data: ResetPasswordRequest) => {
    setIsSubmitting(true);
    setErrorState(null);

    try {
      await authApi.resetPassword(data);
      setIsSuccess(true);
    } catch (error: unknown) {
      const apiError = error as ApiError;
      const data = apiError?.response?.data;
      const errorCode = data?.title || data?.code || data?.type;
      const statusCode = apiError?.response?.status;
      const errorMsg = getErrorMessage(errorCode, statusCode, data?.detail);
      setErrorState({ title: errorMsg.title, message: errorMsg.message });
    } finally {
      setIsSubmitting(false);
    }
  };

  return { resetPassword, isSubmitting, isSuccess, errorState };
}
